import { render, staticRenderFns } from "./AttachmentsUploadForm.vue?vue&type=template&id=2efab259"
import script from "./AttachmentsUploadForm.vue?vue&type=script&lang=js"
export * from "./AttachmentsUploadForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports